var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { styled } from 'styled-components';
import { LinkButton, TextButton } from '@hn-ui/buttons';
import { Down, Repeat, Up } from '@hn-ui/icons';
import { isStudentCell } from '../tableConfig';
import { CancelButton as CancelBtn } from '../../../../../components/CancelButton';
import { isStudentAssignmentFinished } from '../../../../../constants/statuses';
import { Tooltip } from '@hn-ui/tooltips';
var ScCell = styled.div.withConfig({ displayName: "ScCell", componentId: "sc-1v8jhl6" })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: flex-end;\n  gap: 0 16px;\n\n  > * {\n    width: auto;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 24px;\n    gap: 4px;\n  }\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  gap: 0 16px;\n\n  > * {\n    width: auto;\n    font-weight: 700;\n    font-size: 14px;\n    line-height: 24px;\n    gap: 4px;\n  }\n"])));
var ScLinkButton = styled(LinkButton).withConfig({ displayName: "ScLinkButton", componentId: "sc-8fw42n" })(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  gap: 0 4px;\n"], ["\n  gap: 0 4px;\n"])));
var DetailsButton = function (_a) {
    var studentId = _a.studentId, isExpanded = _a.isExpanded, onDetailsClick = _a.onDetailsClick;
    return (_jsxs(ScLinkButton, __assign({ onClick: function () { return onDetailsClick === null || onDetailsClick === void 0 ? void 0 : onDetailsClick(studentId); } }, { children: [_jsx("span", { children: "Details" }, void 0), isExpanded ? _jsx(Up, { size: 16 }, void 0) : _jsx(Down, { size: 16 }, void 0)] }), void 0));
};
var ReassignButton = styled(TextButton).withConfig({ displayName: "ReassignButton", componentId: "sc-1bq61yf" })(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  padding: 0;\n"], ["\n  padding: 0;\n"])));
var RepeatIcon = function () { return _jsx(Repeat, { size: 16 }, void 0); };
var CancelButton = function (_a) {
    var student = _a.student, onCancelClick = _a.onCancelClick;
    return (_jsx(CancelBtn, { showIcon: true, onClick: function (evt) {
            evt.stopPropagation();
            onCancelClick === null || onCancelClick === void 0 ? void 0 : onCancelClick(student);
        } }, void 0));
};
export var ActionsCell = function (_a) {
    var assignmentId = _a.assignmentId, allowReassign = _a.allowReassign, row = _a.row, onCancelClick = _a.onCancelClick, onDetailsClick = _a.onDetailsClick, onReassignClick = _a.onReassignClick;
    if (!isStudentCell(row.original))
        return null;
    var _b = row.original, id = _b.id, status = _b.status;
    var buttons = [];
    if (!isStudentAssignmentFinished(status)) {
        buttons.push(_jsx(CancelButton, { student: row.original, onCancelClick: onCancelClick }, 'cancel'), _jsx(DetailsButton, { studentId: id, onDetailsClick: onDetailsClick, isExpanded: row.isExpanded }, 'details'));
    }
    else {
        buttons.push(_jsx(Tooltip, __assign({ interactive: !allowReassign, content: 'The assignment cannot be reassigned because the tasks were deleted from the platform by our content team.', maxWidth: 340 }, { children: _jsx(ReassignButton, __assign({ fit: true, LeftIcon: RepeatIcon, disabled: !allowReassign, onClick: function (event) {
                    event.stopPropagation();
                    onReassignClick === null || onReassignClick === void 0 ? void 0 : onReassignClick(assignmentId, id);
                } }, { children: "Reassign" }), void 0) }), 'reassign'), _jsx(DetailsButton, { studentId: id, onDetailsClick: onDetailsClick, isExpanded: row.isExpanded }, 'details'));
    }
    return _jsx(ScCell, { children: buttons }, void 0);
};
var templateObject_1, templateObject_2, templateObject_3;
